import { IS_SERVER } from './checkRenderEnv';

export const formatPriceToINR = (price) => {
  if (!price) return price;
  if (IS_SERVER) return price;
  return price.toLocaleString?.('en-IN') || price;
};
